var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.084,
    height: 20.524,
    viewBox: "0 0 14.084 20.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-list",
    transform: "translate(-80.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365923",
    "data-name": "Path 365923",
    d: "M93.815,32.134h-2.06v.686a1.8,1.8,0,0,1-1.8,1.8H84.8a1.8,1.8,0,0,1-1.8-1.8v-.686h-2.06a.6.6,0,0,0-.6.6V50.748a.6.6,0,0,0,.6.6H93.815a.6.6,0,0,0,.6-.6V32.735A.6.6,0,0,0,93.815,32.134ZM85.224,45.82a.6.6,0,0,1-.85.849l-.219-.219-.219.219a.6.6,0,0,1-.85-.849L83.3,45.6l-.219-.219a.6.6,0,1,1,.85-.849l.219.219.219-.219a.6.6,0,1,1,.85.849L85,45.6Zm.644-4.3L84.58,42.81a.6.6,0,0,1-.85,0l-.644-.643a.6.6,0,1,1,.85-.849l.219.219.863-.862a.6.6,0,1,1,.85.849Zm0-3.86L84.58,38.949a.6.6,0,0,1-.85,0l-.644-.643a.6.6,0,1,1,.85-.849l.219.219.863-.862a.6.6,0,1,1,.85.849ZM91.239,46.2h-3.22a.6.6,0,1,1,0-1.2h3.22a.6.6,0,1,1,0,1.2Zm0-3.86h-3.22a.6.6,0,1,1,0-1.2h3.22a.6.6,0,1,1,0,1.2Zm0-3.86h-3.22a.6.6,0,1,1,0-1.2h3.22a.6.6,0,1,1,0,1.2Z",
    transform: "translate(0 -30.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365924",
    "data-name": "Path 365924",
    d: "M177.344,2.618h5.236a.611.611,0,0,0,.611-.611V.611A.611.611,0,0,0,182.58,0h-5.236a.611.611,0,0,0-.611.611v1.4A.611.611,0,0,0,177.344,2.618Z",
    transform: "translate(-92.587)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/check-list.6fd8d8fb6b3d3f0ff907e7787503e5e9.svg";
export { ForwardRef as ReactComponent };